import { getApiActionTypes } from '../../../../shared/store/storeHelpers';

export const fetchSltAmountDetailsTypes = getApiActionTypes('FETCH_SLT_AMOUNT_DETAILS');
